import React, { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFetchDashboardProjectDetailsQuery } from "../../slice/logdetailSlice";
import Loader from "../common/Loader";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";


const ITEMS_PER_PAGE = 10;

const ProjectCard = ({ projectName, progress, projectId, owner_name }) => {
  const navigate = useNavigate();
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // const { role: login_user_role } = login_user;
  const { role: login_user_role } = login_user || {};

  const handleClick = () => {
    login_user_role !== "CLIENT"
      ? navigate(`/projects/projectDetail/${projectId}`)
      : navigate(`/projects/projectDetail/${projectId}/tasks`);
  };

  return (
    <>
      <div className="card-body p-0" onClick={handleClick}>
        <p className="card-title">{projectName}</p>
        <div className="d-flex justify-content-between">
          <div
            className="d-flex  align-items-center  mb-2"
            style={{ color: "rgba(98, 97, 97, 1)" }}
          >
            <FaUser className="me-2" style={{ color: "rgba(98, 97, 97, 1)" }} />{" "}
            Owner
            <span style={{ color: "rgba(98, 97, 97, 1)" }} className="ms-3">
              {owner_name || "N/A"}
            </span>
          </div>
          <div>
            <div
              className="progress"
              style={{
                height: "12px",
                width: "60px",
                backgroundColor: "var(--header-bg-color)",
              }}
            >
              <div
                className="progress-bar rgba-green"
                role="progressbar"
                style={{ width: `${progress}%` }}
                aria-valuenow={progress}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <small className="d-block text-rgba-blue mt-2">{progress}%</small>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
};

export const RecentProjects = ({ onSeeMore }) => {
  const {
    data: project_details = [],
    isError,
    isLoading: project_loading,
    refetch: project_details_refetch,
  } = useFetchDashboardProjectDetailsQuery();

  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // const { role: login_user_role } = login_user;
  const { role: login_user_role } = login_user || {};

  const [currentPage, setCurrentPage] = useState(1);

  // RTK Query automatically fetches on mount; redundant refetch on mount removed

  const totalPages = Math.ceil(project_details.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedProjects = project_details.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <>
      {project_loading ? (
        <Loader />
      ) : (
        <div className="container tableScroll bg-white p-3 rounded-3">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="d-flex align-items-center">
              <h5 className="cardsub_title mb-0 pe-3">
                {login_user_role === "ADMIN" || login_user_role === "CLIENT"
                  ? "All Active Projects"
                  : "Active Projects"}
              </h5>
              <div className="cardsub_title_line"></div>
            </div>
            <div className=" text-rgba-gray">
              Total Projects: <strong>{project_details.length}</strong>
            </div>
          </div>

          <div style={{ cursor: "pointer" }}>
            {paginatedProjects.length > 0 ? (
              paginatedProjects.map((project) => (
                <ProjectCard
                  key={project.project_id}
                  projectName={project.title}
                  owner_name={project.owner_name}
                  progress={project.completed_percentage}
                  projectId={project.project_id}
                />
              ))
            ) : (
              <p className="text-muted">No projects available.</p>
            )}
          </div>

          {/* Pagination Controls */}
          {project_details.length > ITEMS_PER_PAGE && (
            <div className="d-flex justify-content-end align-items-center mt-3">
              <FaChevronLeft
                onClick={currentPage === 1 ? null : handlePrev}
                className={`mx-2 ${
                  currentPage === 1
                    ? "text-muted pointer-events-none"
                    : "cursor-pointer"
                }`}
                style={{
                  opacity: currentPage === 1 ? 0.3 : 1,
                  cursor: currentPage === 1 ? " not-allowed " : "pointer",
                }}
              />
              <span className="mx-2">{`Page ${currentPage} of ${totalPages}`}</span>
              <FaChevronRight
                onClick={currentPage === totalPages ? null : handleNext}
                className={`mx-2 ${
                  currentPage === totalPages
                    ? "text-muted pointer-events-none"
                    : "cursor-pointer"
                }`}
                style={{
                  opacity: currentPage === totalPages ? 0.3 : 1,
                  cursor:
                    currentPage === totalPages ? " not-allowed " : "pointer",
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};
